export const docsInfoDefaultContent = {info: 'INFO1', component: 'Info1'};
export const docsInfoStaticContentScreens = [
  {display: 'Getting Started', component: 'Info1'},
  {display: 'Authorization', component: 'Info2'},
  {display: 'API Usage', component: 'Info3'}
];
export const docsInfoDynamicContentScreen = 'ApiInfo';
